import React, { FC } from 'react'
import { SimpleContentProps } from './SimpleContent.types'
import { sanitizeHTML } from '../../../utils/common-utils'

export const SimpleContent: FC<SimpleContentProps> = props => {
  const { title, intro, publishDate, publishTime, content, button, vertSpacing, bgColor } =
    props.content

  const { brandExtension, testId } = props

  const buildButton = () => {
    const { linkHref, linkTarget, analytics, linkText } = button
    return (
      <a
        className='Button Button--primary u-marginVert2gu'
        href={linkHref}
        target={linkTarget}
        data-analytics={analytics ?? ''}>
        {linkText}
      </a>
    )
  }

  return (
    <section
      className={`SimpleContent ${vertSpacing} ${bgColor} ${brandExtension}`}
      data-testid={testId ? `${testId}` : null}>
      <div className={`u-sizeConstrained ${bgColor?.length !== 0 && 'u-paddingVert10gu'}`}>
        <header>
          {title && <h1>{sanitizeHTML(title)}</h1>}
          {(intro || publishDate) && (
            <div className='SimpleContent-subtitle u-marginBottom6gu u-textSizeMsrp1 u-textDefault'>
              {intro && <p className='SimpleContent-introduction'>{intro}</p>}
              {publishDate && (
                <time className='SimpleContent-publishDate' dateTime={publishTime}>
                  {publishDate}
                </time>
              )}
            </div>
          )}
        </header>

        {content && (
          <div className='Content' dangerouslySetInnerHTML={{ __html: sanitizeHTML(content) }} />
        )}
        {button && buildButton()}
      </div>
    </section>
  )
}
